<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="departments_new" ttGoto="department" [ttGotoParms]="{ department_id: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListDepartments"></tt-list>
</tt-page>
